import { render, staticRenderFns } from "./_purchaser.vue?vue&type=template&id=79fe6ee2&"
import script from "./_purchaser.vue?vue&type=script&lang=js&"
export * from "./_purchaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports